$(document).ready(function(e){
  // about purely for you page -  slider
  if($('.js-about-featured-slider').length) {
    $('.js-about-featured-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }

 // pure difference slider
  if($('.js-pure-difference-slider').length) {
    $('.js-pure-difference-slider').slick({
      arrows: true,
      dots: true,
      adaptiveHeight: true
    });
  }


 // accordion
  $('.js-expand-collapse').on('click keypress', function(e){
     console.log("test0");
    e.preventDefault(0);

    if(a11yClick(event) === true){
      let $target = $(this).next('.js-tab-content');
      if ($target.length > 0) {
        $('.js-expand-collapse').not(this).removeClass('active');
        //$('.js-expand-collapse').parent().parent().removeClass('active');
        $target.slideUp(300);

        if ($target.is(':hidden')) {
          $(this).addClass('active');
          $target.slideDown(300);
           $target.parent().parent().addClass('active');
          console.log("test1");
        }
        else {
          $(this).removeClass('active');
           $(this).parent().parent().removeClass('active');
          $target.slideUp(300);
          console.log("test2");
        }
      }
      else {
        $(this).toggleClass('active');
         $target.parent().parent().toggleClass('active');
        let targetId = $(this).attr('href');
        $(targetId).slideToggle(300);
        console.log("test3");
      }
    }
  }); 
  // Set height of product title (uniform height)
  if($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
    let $el =  $('.js-product-card__title');
    let maxHeight = 0;
    $el.each(function(){
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $el.height(maxHeight);

    // Show number of products per page
    if($('#productPerPageSelector').length) {
      $('#productPerPageSelector').on('change', function(){
        window.location.replace($(this).val());
      });
    }
  }

/**
* Ajaxify Cart for Product Listings sections
* ----------------------------------------------------------------------------- */
Shopify.AjaxifyCart = (function($) {
  var _config = {
    addToCartBtnLabel:             'Add to cart',
    soldOutBtnLabel:               'Sold Out',
    howLongTillBtnReturnsToNormal: 1200, // in milliseconds.
    howLongTillCartPopupShow:      1650,
    cartCountContainer:           '[data-cart-count-bubble]',
    cartCountSelector:             '[data-cart-count], [data-cart-popup-cart-quantity]',
    loader:                       '[data-loader]',

    addToCartBtnSelector:          '[data-item-add-to-cart]',
    addToCartBtnText:             '[data-item-add-to-cart-text]',
    addToCartFormSelector:         '[data-product-listing-form]',
    shopifyAjaxAddURL:             '/cart/add.js',
    shopifyAjaxCartURL:            '/cart.js'
  };

  function showCartPopup(item, qty) {
    $('[data-cart-popup-wrapper]').prepareTransition().removeClass('cart-popup-wrapper--hidden');
    $('[data-cart-popup-title]').text(item.title);
    $('[data-cart-popup-quantity]').text(qty);
    $('[data-cart-popup-image-wrapper]').removeClass('hide');
    $('[data-cart-popup-image]').remove();

    let imageUrl = item.featured_image.url;
    let imageAlt = item.featured_image.alt;
    if (imageUrl === null) return;
    let sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
    let image = document.createElement('img');
    image.src = sizedImageUrl;
    image.alt = imageAlt;
    image.classList.add('cart-popup-item__image');
    image.dataset.cartPopupImage = '';

    image.onload = function() {
      $('[data-cart-popup-image-placeholder]').addClass('hide');
      $('[data-cart-popup-image-wrapper]').append(image);
    }.bind(this);

    $('[data-cart-popup-close],[data-cart-popup-dismiss]').on('click', hideCartPopup.bind(this));

    $('body').on('click', function(event){
      var $target = $(event.target);
      if($('[data-cart-popup-wrapper]').is(':visible')) {
        if ($target[0] !== $('[data-cart-popup-wrapper]')[0] && !$target.parents('[data-cart-popup]').length) {
          hideCartPopup(event);
        }
      }
    });

    /* Auto add free gift to cart */
    var params = {
      url: '/cart/update.js',
      data: { attributes: { 'gift': 'yes' } },
      dataType: 'json'
    };
    $.post(params);
  }

  function hideCartPopup(event) {
    $('[data-cart-popup-wrapper]').prepareTransition().addClass('cart-popup-wrapper--hidden');
    $('[data-cart-popup-image]').remove();
    $('[data-cart-popup-wrapper], [data-cart-popup-dismiss]').off('click');
    if($('[data-cart-popup-wrapper]').is(':visible')) {
      $('body').off('click');
    }
  }

  var _init = function() {
    $(document).ready(function() {
      $(document).on('submit',_config.addToCartFormSelector, function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);
        var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
        var $addToCartBtnText = $addToCartForm.find(_config.addToCartBtnText);
        var $loader = $addToCartForm.find(_config.loader);
        $addToCartBtn.addClass('disabled').prop('disabled', true);
        // Add to cart.
        $.ajax({
          url: _config.shopifyAjaxAddURL,
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          success: function(data) {
            $loader.removeClass('hide');
            $addToCartBtnText.hide();

            window.setTimeout(function(){
              $loader.addClass('hide');
              $addToCartBtn.prop('disabled', false).removeClass('disabled');
              $addToCartBtnText.show();
            }, _config.howLongTillBtnReturnsToNormal);

            window.setTimeout(function(){
              showCartPopup(data, 1);
            }, _config.howLongTillCartPopupShow);

            // Update cart count and show cart link.
            $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
              if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                var value = $(_config.cartCountSelector).html() || '0';
                $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count));
                $(_config.cartCountContainer).removeClass('hide');
              }
            });
          },
          error: function(XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            if (response.slice(0,4) === 'All ') {
              console.log("Error: "+response.replace('All 1 ', 'All '));
              $addToCartBtn.prop('disabled', false);
              $addToCartBtnText.text(_config.soldOutBtnLabel);
              $addToCartBtn.prop('disabled',true);
            }
            else {
              console.log("Error: "+response);
              $addToCartBtn.prop('disabled', false).removeClass('disabled');
              _setText($addToCartBtnText, _config.addToCartBtnLabel);
              $addToCartBtnText.text(config.addToCartBtnLabel);
            }
          }
        });
        return false;
      });
    });
  };
  return {
    init: function(params) {
        // Configuration
        params = params || {};
        // Merging with defaults.
        $.extend(_config, params);
        // Action
        $(function() {
          _init();
        });
    },
    getConfig: function() {
      return _config;
    }
  }
  
 
})(jQuery);

  if($('[data-item-add-to-cart]').length && !$('body').hasClass('template-search')) {
    //Shopify.AjaxifyCart.init();
  }  

 if ($(window).width() < 1021) {
       $('.aboutblockinner').slick({
      arrows: true,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }   
    // mobile nav
  $('.js-toggle-nav').on('click', function(){
    $(this).toggleClass('active');
    $('#mobileNavWrapper').slideToggle(300);
    $(this).parents('.site-header').toggleClass('active');
    $('body').toggleClass('no-scroll');
  });

  $(".has-top-bar .mobile-nav-btn,.has-top-bar .mobile-nav-btn--des").click(function(){
      $(".announcement-bar").toggleClass("mob-nav-active");
  }); 
});